import { convertStyleData } from '@utils/tools';
import { Toast } from 'antd-mobile';
import './AdvertisingCustomComponent.less';

export default function AdvertisingCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const imgStyle = {
    width: '100%',
  }
  const showToast = ()=> {
    Toast.info('仅为预览图效果，实际功能请在小程序端体验(该组件仅支持微信小程序)')
  }
  styleObj['height'] = 'unset';
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  return (
    <div className="custom-component" style={styleObj} onClick={showToast}>
      <img style={imgStyle} src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/advertising1.png" alt="广告组件（仅支持微信小程序）"/>
      {/* <p>广告组件（仅支持微信小程序）</p>
      {
        !data.customFeature['advertisingId'] && <p>未填写广告ID</p>
      } */}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/advertising-custom-component/AdvertisingCustomComponent.jsx